module.exports = {"data":[{"observationName":"Speeding","scorePercentage":51.5,"observationCount":3},{"observationName":"Unsafe Driving","scorePercentage":0.5,"observationCount":2},{"observationName":"You just got really <CRAZY /> after drinking 64 ounces of Mountain Dew","scorePercentage":10,"observationCount":1},{"observationName":"My score is excatly NULL: (null/undefined)","scorePercentage":null,"observationCount":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/__mockData__/observations.json
// module id = 2256
// module chunks = 0